module.exports = __webpack_public_path__ + "img/img1.f722ca0f.png";